import ScrollObserver from "./ScrollObserver.js";

class InView {
  #observers = [];
  constructor() {
    this.#init();
  }
  #init() {
    this.#observers.push(
      new ScrollObserver('[data-in-view-animation]', this.#inViewAnimation, { rootMargin: "-100px 0px" })
    )
  }
  #inViewAnimation(elm, inView) {
    if(inView) {
      elm.classList.add('_in_view');
    } else {
      elm.classList.remove('_in_view');
    }
  }
}
export default InView;